module.exports = __webpack_public_path__ + "img/second_zhCn_new.2443622b.png";